<div class="add-row justify-content-center flex">
  <div class="btn add-button button-blue flex-basis-35 border-radius-5 fs-16 flex justify-content-center" [ngClass]="{'disabled': isDisabled}" (click)="addClicked.emit()">
    <span class="align-self-center">{{buttonText}}</span>
  </div>
</div>
